module.exports = __webpack_public_path__ + "static/Commune-Nuit_Debout_web-6614383e13f0f90a88e030a282087995.woff";